import React, { Component } from 'react';
import PanelFilter from './PanelFilter';

const lodash = require('lodash')

const LABELS_PROFIL = {
  "Vendeur": "Vendeurs",
  "ChefDesVentes": "Chefs des ventes",
  "BDC": "BDC",
  "Conseiller": "Conseillers",
  "WelcomePro": "Welcome Pro",
};

class FilterUtilisateur extends Component {

  constructor(props) {
    super(props);

    this.state = {
      profils: [],
      utilisateurs: [],
      selectedProfils: [],
      selectedUtilisateurs: [],
    }

    this.key = this.props.name || ""
  }

  componentWillMount() {
    this.initUtilisateurs();
  }

  componentDidMount() {
    if (this.props.selected) {
      this.setState({
        selectedUtilisateurs: this.props.selected
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.leads !== prevProps.leads) {
      this.initUtilisateurs();
    }
  }

  initUtilisateurs() {

    // Récupération des utilisateurs affectés
    let utilisateurs = lodash.filter(this.props.leads, (lead) => {
      return lead.SuiviPar && lead.SuiviPar.IDUtilisateur;
    }).map((lead) => {
      return lead.SuiviPar;
    });

    // Dédoublonnage des utilisateurs
    utilisateurs = lodash.uniqBy(utilisateurs, (utilisateur) => {
      return utilisateur.IDUtilisateur;
    });

    // Tri par ordre alphabétique des utilisateurs
    utilisateurs = lodash.sortBy(utilisateurs, (utilisateur) => {
      return utilisateur.Nom;
    })

    // Récupération des différents profils présents
    let profils = lodash.uniq(lodash.map(utilisateurs, (utilisateur) => {
      return utilisateur.TypeProfilLead || '';
    }));

    // Tri par ordre alphabétique des profils
    profils = lodash.sortBy(profils, (profil) => {
      return LABELS_PROFIL[profil] || profil || 'Autres';
    })

    this.setState({
      profils: profils,
      utilisateurs: utilisateurs,
    });
  }

  onChangeProfil(event) {

    const profil = event.target.name;

    let selectedProfils = [...this.state.selectedProfils];
    let selectedUtilisateurs = [...this.state.selectedUtilisateurs];

    if (event.target.checked) {
      selectedProfils.push(profil);

      // Ajout de tous les utilisateurs enfants du profil
      const utilisateursToAdd = lodash.filter(this.state.utilisateurs, (utilisateur) => {
        return (utilisateur.TypeProfilLead || '') === profil;
      }).map((utilisateur) => {
        return utilisateur.IDUtilisateur;
      });
      selectedUtilisateurs = selectedUtilisateurs.concat(utilisateursToAdd);
    }
    else {
      selectedProfils = selectedProfils.filter((p) => p !== profil);

      // Suppression de tous les utilisateurs enfants du profil
      const utilisateursToDelete = lodash.filter(this.state.utilisateurs, (utilisateur) => {
        return (utilisateur.TypeProfilLead || '') === profil;
      }).map((utilisateur) => {
        return utilisateur.IDUtilisateur;
      });

      selectedUtilisateurs = selectedUtilisateurs.filter((idUtilisateur) => utilisateursToDelete.indexOf(idUtilisateur) === -1);
    }

    this.setState({
      selectedProfils: selectedProfils,
      selectedUtilisateurs: selectedUtilisateurs,
    }, () => {
      this.props.onChange('vendeurs', this.state.selectedUtilisateurs);
    });
  }

  onChangeUtilisateur(profil, event) {

    const idUtilisateur = parseInt(event.target.name, 10);

    let selectedProfils = [...this.state.selectedProfils];
    let selectedUtilisateurs = [...this.state.selectedUtilisateurs];

    if (event.target.checked) {
      selectedUtilisateurs.push(idUtilisateur);

      // Si le profil n'est pas sélectionné, on l'ajoute
      if (this.state.selectedProfils.indexOf(profil) <= -1) {
        selectedProfils.push(profil);
      }
    }
    else {
      selectedUtilisateurs = selectedUtilisateurs.filter((id) => id !== idUtilisateur);

      // Si plus d'utilisateur actif pour le profil parent, on décoche le profil parent
      const selectedUtilisateursDuProfil = lodash.filter(this.state.utilisateurs, (utilisateur) => {
        return (utilisateur.TypeProfilLead || '') === profil && selectedUtilisateurs.indexOf(utilisateur.IDUtilisateur) > -1;
      });

      if (selectedUtilisateursDuProfil.length === 0) {
        selectedProfils = selectedProfils.filter((p) => p !== profil);
      }
    }

    this.setState({
      selectedProfils: selectedProfils,
      selectedUtilisateurs: selectedUtilisateurs,
    }, () => {
      this.props.onChange('vendeurs', this.state.selectedUtilisateurs);
    });
  }

  isCheckedUtilisateur(utilisateur) {
    if (this.state.selectedUtilisateurs.indexOf(utilisateur.IDUtilisateur) > -1) {
      return true;
    }

    return false;
  }

  renderUtilisateurs(profil) {

    const utilisateurs = lodash.filter(this.state.utilisateurs, (utilisateur) => {
      return (utilisateur.TypeProfilLead || '') === profil;
    });

    return utilisateurs.map((utilisateur, j) => {
      return (
        <div key={utilisateur.IDUtilisateur} className={'block-height' + (j === 0 ? ' first' : '') + (j === utilisateurs.length-1 ? ' empty ' : '')}>
          <div className="checkbox rank-1">
            <input type="checkbox" id={this.key+'utilisateur-'+utilisateur.IDUtilisateur} name={utilisateur.IDUtilisateur} checked={this.isCheckedUtilisateur(utilisateur)} onChange={this.onChangeUtilisateur.bind(this, profil)} />
            <label className="label-box" htmlFor={this.key+'utilisateur-'+utilisateur.IDUtilisateur}>
              <span className="label-root">{utilisateur.Nom}</span>
              <span className="count"></span>
            </label>
            <div className="clearfix"></div>
          </div>
        </div>
      );
    });
  }

  render() {

    let content;

    if (this.state.profils.length) {
      content = this.state.profils.map((profil, i) => {
        let id = this.key+'profil-'+i;
        return (
          <div key={profil}>
            <div className="global-check">
              <input type="checkbox" id={id} name={profil} onChange={this.onChangeProfil.bind(this)} checked={(this.state.selectedProfils.indexOf(profil) > -1) ? true : false} />
              <label className="label-box" htmlFor={id}>
                <span className="label-root">{LABELS_PROFIL[profil] || profil || 'Autres'}</span>
              </label>
            </div>
            <div  className="block-height first empty">
              {this.renderUtilisateurs(profil)}
            </div>
          </div>);
      });
    }

    return (
      <PanelFilter title="Par utilisateur affecté">
        <div className="panel panel-default panel-leads-filter filters-grad" style={{paddingTop: 5}}>
          <div className="panel-body">
            {content}
          </div>
        </div>
      </PanelFilter>
    );
  }
}

export default FilterUtilisateur;
